import { Injectable } from '@angular/core';

@Injectable()
export class NotificationService {
    //Variavel que contém um array de objetos com o conteúdo das notificações
    public notificacoes: Array<INotification> = [];

    constructor() {
        //
    }

    /**
     * showNotification(title?: string, content?: string, img?: string)
     * 
     * Mostra a notificação
     * 
     * William Oliveira
     * 
     * 08/2018
     * 
     * @param title?: string
     * @param content?: string
     * @param img?: string
     * @param button?: INotificationButton { title, link }
     */
    public showNotification(params: INotification) {

        let show = true;
        if(params.content)
            for(let notication of this.notificacoes)
                if(notication.content && params.content == notication.content)
                    show = false;

        if(show)
            this.notificacoes.push(params)
    }

    /**
     * close(index)
     * 
     * Fecha a notificação
     * 
     * William Oliveira
     * 
     * 08/2018
     * 
     * @param index int
     */
    public close(index) {
        this.notificacoes.splice(index, 1);
    }


}

/**
 * Interface para Notificações
 */
export interface INotification {
    title?: string,
    content?: string,
    img?: string,
    button?: INotificationButton
}

/**
 * Interface para Botões
 */
export interface INotificationButton {
    title?: string,
    link?: string
}



// WEBPACK FOOTER //
// ./src/services/notification.service.ts